<template id="temp">
    <!-- vue实例外创建 -->
    <div class="mnbox">
        <div class="mncontent">
            <div class="mnHeadr">
                <div :class="active == 1 ? 'tab active' : 'tab '" @click="tab(1)" v-show="show">管理测评</div>
                <div :class="active == 2 ? 'tab active' : 'tab '" @click="tab(2)">我的测评</div>
                <div class="see" v-if="false"> <span style="color: #0F6CF5;">
                        <i
                            class="el-icon-tickets
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             "></i>
                        企业测评统计数据查看
                    </span>
                    <i class="el-icon-arrow-right"></i>
                </div>

            </div>

        </div>

        <div class="mnlist" v-if="active == 1">
            <div class="mnlist1" v-if="manageList.length && show">
                <div class="cpLsit" v-for="item in manageList " :key="item.examDeptId">
                    <div class="cpLsit_nam">
                        <div class="cpLsit_nam1">{{ item.title }}</div>
                        <div class="cpLsit_nam2">相关：{{ item.content }}
                        </div>
                    </div>
                    <div class="cpLsit_user">已分配: {{ item.userCount ? item.userCount : 0 }}人</div>
                    <div class="cpLsit_bb" @click="goCP(item)">管理测评</div>
                    <div class="cpLsit_cp" @click="tjbb(item)">统计报表</div>

                </div>
                <!-- <div v-if="currentPageType1 && manageList.length >= 10"
                    style="height: 50px;line-height: 50px; color: #0F6CF5;cursor: pointer;" @click="viewMore1">
                    查看更多<i class="el-icon-d-arrow-right"></i>
                </div>
                <div v-else style="height: 50px;line-height: 50px; color: #ccc;">
                    暂无更多数据

                </div> -->
            </div>
            <div class="mnlist1" v-else>
                <div class="zwt">
                    <img src="../assets/img/zwsj.png" alt="">

                </div>
                <div style="width: 100%; text-align: center;font-size: 22px;color: #9B9FAA;">
                    <span v-if="show"> 测评卷即将上线，敬请等待~</span>
                    <span v-else>您所在企业暂无测评权限，可联系您的课程顾问获取帮助！</span>
                </div>
            </div>
        </div>
        <div class="mnlist" v-else>

            <div class="mnlist2" v-if="userList.length">
                <div class="cpLsit" v-for="item in userList " :key="item.examDeptId">

                    <div class="cpLsit_nam">
                        <div class="cpLsit_nam1">{{ item.title }}</div>
                        <div class="cpLsit_nam2">相关：{{ item.content }}
                        </div>
                    </div>
                    <!-- //试卷状态：0=未开始、1=进行中、2=已结束 -->
                    <div class="cpLsit_bb cpLsit_bb2" v-if="item.status == 0">等待开放</div>
                    <div class="cpLsit_bb " v-if="item.status == 1" @click="cp(item)">开始测评</div>
                    <div class="cpLsit_bb cpLsit_bb1" v-if="item.status == 2">试卷关闭</div>
                </div>
                <!-- <div v-if="currentPageType2 && userList.length >= 10"
                    style="height: 50px;line-height: 50px; color: #0F6CF5;cursor: pointer;" @click="viewMore2">
                    查看更多<i class="el-icon-d-arrow-right"></i>
                </div>
                <div v-else style="height: 50px;line-height: 50px; color: #ccc;">
                    暂无更多数据!
                </div> -->

            </div>
            <div class="mnlist2" v-else>
                <div class="zwt">
                    <img src="../assets/img/zwsj.png" alt="">

                </div>
                <div style="width: 100%; text-align: center;font-size: 22px;color: #9B9FAA;"> 您暂无测评卷，请耐心等待您的管理员为您分配</div>

            </div>
        </div>
    </div>
</template>
<!-- 调用   <mycom></mycom> -->
<script>
import { deptExamList, myExamList } from '@/api/index';
export default {
    name: 'mncp',
    data() {
        return {
            value2: null,
            active: 1,
            show: false,
            manageList: [],
            userList: [

            ],
            currentPage1: 1,
            currentPageType1: true, currentPageType2: true,
            currentPage2: 1,

            token: null,
        }
    },
    created() {
        // if (this.$route.params.token) {
        //     this.token = this.$route.params.token

        // }
        // if (localStorage.getItem('token')) {
        //     this.token = localStorage.getItem('token');
        // }
           this.token = localStorage.getItem('token');
        this.dept = localStorage.getItem('dept');

        var index = window.localStorage.getItem('mntabActive')
        this.active = index ? index : 1
        if (JSON.parse(localStorage.getItem('user'))) {
            var user = JSON.parse(localStorage.getItem('user'))
            if (user.role == 2) {
                this.show = true;
            } else {
                this.active = 2
                this.show = false
            }
        }

        this.tab(this.active)

    },
    methods: {
        viewMore1: function () {
            if
                (this.currentPageType1) {
                this.currentPage1 = this.currentPage1 + 1;
                this.getmanageList();
            }
        },
        viewMore2: function () {


            if
                (this.currentPageType2) {
                this.currentPage2 = this.currentPage2 + 1;
                this.getuserList();
            }
        },
        tab: function (index) {
            this.active = index
            this.currentPage1 = 1
            this.currentPage2 = 1
            this.currentPageType1 = true
            this.currentPageType2 = true
            window.localStorage.setItem('mntabActive', index)
            if (index == 1) {
                this.manageList = []
                this.getmanageList(1)
            } else {
                this.userList = []
                this.getuserList(1)


            }
        },
        getmanageList: function (num) {

            deptExamList({ pageNum: this.currentPage1, pageSize: 10 }, { Authorization: this.token }).then(res => {
                if (res.code == 200) {

                    var dataArr = this.manageList;
                    this.manageList = dataArr.concat(res.data.list);
                    if (!num) {
                        if (res.data.list.length == 0) {
                            this.currentPageType1 = false
                            this.$message({
                                message: "没有更多了",
                                type: "warning",
                            });
                        }
                    }

                }

            })
        },
        getuserList: function (num) {
            myExamList({
                pageNum: this.currentPage2, pageSize: 10
            }, { Authorization: this.token }).then(res => {
                if (res.code == 200) {
                    var dataArr2 = this.userList;
                    this.userList = dataArr2.concat(res.data.list)
                    if (!num) {
                        if (res.data.list.length == 0) {
                            this.currentPageType2 = false
                            this.$message({
                                message: "没有更多了",
                                type: "warning",
                            });
                        }
                    }

                }
            })
        },
        tjbb: function (item) {



            if (item.status != 2 || item.userCount <= 0) {

                this.$message({
                    message: "未分配人员/已分配人员测评未完成!",
                    type: "warning",
                });
                return;
            }

            this.$router.push(`/statistics/${item.examId}/${item.title}`)
        },
        goCP: function (item) {
            console.log(item)
            this.$router.push(`/Management_evaluation/${item.examDeptId}/${item.title}`)
        },
        cp(row) {
            if (row.userPaperId) {
                this.$router.push({
                    path: `/report`,
                    query: {
                        userPaperId: row.userPaperId,
                    }
                });
            } else {
                this.$router.push({
                    path: `/exam/${row.examId}`,
                    query: {
                        ksid: '-1',
                    }
                });
            }

        },
    }
}
</script> 
<style scoped lang="less" >
.zwt {
    width: 250px;
    height: 180px;
    margin: auto;
    margin-top: 150px;
}

.mnbox {
    width: 100%;


}

.mncontent {
    height: auto;
    width: 100%;

    background: #fff;
}

.mnHeadr {
    width: 1200px;
    margin: 0 auto;
    height: 90px;
    font-size: 18px;
    background: #fff;
    display: flex;

    position: relative;

}

.mnlist {
    width: 1200px;
    margin: 20px auto;
    height: 700px;

    background: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;
    overflow-y: auto;

    .mnlist1 {
        width: 90%;
        margin: 0 auto;
        text-align: center;

        height: 140px;


    }

    .mnlist2 {
        width: 90%;
        margin: 0 auto;
        text-align: center;
        height: 140px;



    }

    .mnlist2 .cpLsit_nam {

        width: 85%;
    }

    .cpLsit {
        width: 100%;
        height: 100%;
        display: flex;
        text-align: left;
        border-bottom: 1px solid #F0F0F0;

    }

    .cpLsit_nam {
        width: 55%;

        height: 100%;



        .cpLsit_nam1 {
            width: 100%;
            font-size: 18px;
            font-weight: bold;
            height: 90px;
            line-height: 110px;
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .cpLsit_nam2 {
            width: 100%;
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            color: #999999;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

    }

    .cpLsit_user {
        width: 150px;
        height: 35px;
        border-radius: 17px;

        margin-top: 65px;
        margin-left: 30px;
        background: #FF9645;
        text-align: center;
        line-height: 35px;
        color: #fff;
        font-size: 14px;
    }

    .cpLsit_cp {
        cursor: pointer;
        margin-top: 60px;
        width: 108px;
        margin-left: 30px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #FF9645;
        font-size: 14px;
        border-radius: 6px;
        border: 1px solid #FF9645;
    }

    .cpLsit_bb {
        cursor: pointer;
        width: 108px;
        height: 40px;
        border-radius: 6px;
        border: 1px solid #3E63EE;
        color: #3E63EE;
        text-align: center;
        line-height: 40px;
        font-size: 14px;
        margin-top: 60px;
        margin-left: 3%;
    }

    .cpLsit_bb1 {
        border: 1px solid #9DA5AE;
        color: #9DA5AE;
    }

    .cpLsit_bb2 {
        border: 1px solid #FF9645;
        color: #FF9645;
    }

}

.tab {
    height: 50px;
    line-height: 50px;
    margin-right: 40px;
    margin-top: 10px;
    cursor: pointer;
}

.active {
    height: 50px;
    line-height: 50px;

    border-bottom: 2px solid #0F6CF5;

}

.see {
    cursor: pointer;
    padding: 0 10px;
    width: auto;
    height: 40px;
    font-size: 15px;
    line-height: 40px;
    background: #E1E1EB;
    border-radius: 17px;
    position: absolute;
    right: 20px;
    top: 12px;
}
</style>